import { useSelector } from 'react-redux';

import { Author } from '../../../components/Author';
import { getAnswerById } from '../../../selectors/answers';

interface IAuthorContainerProps {
  answerId: string;
}

export function AuthorContainer({ answerId }: IAuthorContainerProps) {
  const { user, date } = useSelector(getAnswerById(answerId));

  return <Author name={user.name} avatarUrl={user.avatarUrl} date={date} />;
}
